import { render, staticRenderFns } from "./VasionDropList.vue?vue&type=template&id=641b8fac&scoped=true&"
import script from "./VasionDropList.vue?vue&type=script&lang=js&"
export * from "./VasionDropList.vue?vue&type=script&lang=js&"
import style0 from "./VasionDropList.vue?vue&type=style&index=0&id=641b8fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b8fac",
  null
  
)

export default component.exports